{
  "version": 1,
  "asset_id": "5232ae6e-8a0e-47c2-b198-8655fb7516da",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/5232ae6e-8a0e-47c2-b198-8655fb7516da/warmtepomp-480.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/5232ae6e-8a0e-47c2-b198-8655fb7516da/warmtepomp-480.avif",
  "original_filename": "warmtepomp-480.avif",
  "size": 8225,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:05:38Z"
}
